<template>
  <div class="form-check mb-2" :class="containerClass">
    <input
      :style="cssProps"
      ref="inputControl"
      :disabled="disabled"
      class="form-check-input"
      :class="checkBoxClassComputed"
      :checked="checkBoxValue"
      type="checkbox"
      :id="id == '' ? 'flexCheckDefault' : id"
      @click="checkBoxClick($event)"
    />
    <label
      class="form-check-label"
      :for="disabled ? '' : id == '' ? 'flexCheckDefault' : id"
    >
      {{ title }}
    </label>
    <span v-if="required" class="text-danger mx-1">*</span>
    <div v-if="!validated" :class="errorClass">
      <small class="text-danger">{{ errorText }}</small>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return { validated: true };
  },
  props: {
    id: {
      type: String,
      required: false,
      default: '',
    },
    errorClass: {
      type: String,
      required: false,
      default: 'text-danger',
    },
    errorText: {
      type: String,
      required: false,
      default: '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    iconName: {
      type: String,
      required: false,
    },
    checkBoxValue: {
      type: Boolean,
      required: false,
      default: false,
    },
    checkBoxClass: {
      type: String,
      required: false,
      default: '',
    },
    containerClass: {
      type: String,
      required: false,
      default: '',
    },
    color: {
      type: String,
      required: false,
      default: '#1b2a4e',
    },
  },
  computed: {
    checkBoxClassComputed() {
      return `${this.checkBoxClass} ${!this.validated ? 'isNotValid' : ''} `;
    },
    cssProps() {
      return {
        '--color': this.color,
      };
    },
  },
  methods: {
    checkBoxClick(e) {
      this.$emit('update:checkBoxValue', e.target.checked);
      this.$emit('checkboxOnChanged', e.target.checked);
    },
    setFocus() {
      this.$refs.inputControl.focus();
    },
    showErrorMessage() {
      this.validated = false;
    },
    hideErrorMessage() {
      this.validated = true;
    },
  },
};
</script>

<style scoped>
.form-check,
.form-check-input {
  float: right;
  margin: 0px;
  margin-left: 3px;
}
.form-check-input:checked[type='checkbox'] {
  background-color: var(--color) !important;
  border-color: var(--color) !important;
}
</style>
